import BaseService from "./geral/BaseService";
import {objetoParaQueryString} from "../utils/formatar";

const base = "Bookings";

export default class BookingService extends BaseService {
    constructor() {
        super(base);
    }
    carregar(id){
        return super.httpGet(`/${base}/Carregar/${id}`)
    }
    listar () {
        return super.httpGet(`/${base}`);
    }

    listarComDetalhes (filtro) {
        let str = objetoParaQueryString(filtro);
        return super.httpGet(`/${base}/Listar/?${str}`);
    }
    listarDetalhes (unit) {        
        return super.httpGet(`/${base}/Listar/?Nbr=${unit}&TamanhoPagina=400`);
    }
    listarOperacoes(){
        return super.httpGet(`/${base}/Operacoes`);
    }
}


// WEBPACK FOOTER //
// ./src/services/BookingService.js